import { MessageCircle, Mail } from 'lucide-react';
import { LAYOUT_FOOTER } from '@/shared/components/layout/tokens';
import {
  LANDING_ANCHORS,
  LANDING_CONTACT,
  LANDING_NAV,
  LOGIN_PATH,
} from '../../domain/landingContent';

/** Rodapé rico da landing — links, contato e legal. */
export function LandingFooter() {
  const ano = new Date().getFullYear();

  return (
    <footer className={`${LAYOUT_FOOTER} border-white/[0.06]`}>
      <div className="mx-auto max-w-6xl px-4 pb-[env(safe-area-inset-bottom,0px)] sm:px-6">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2 lg:col-span-1">
            <img src="/LOGO.png" alt="DS Espetos Grill" className="h-10 w-auto opacity-90" />
            <p className="mt-4 max-w-xs text-xs leading-relaxed text-slate-500">
              Já na rede Espetos Grill. Jukebox, futebol ao vivo e controle das TVs — sem hardware
              proprietário.
            </p>
          </div>

          <div>
            <h3 className="text-xs font-semibold uppercase tracking-wider text-slate-400">
              Navegação
            </h3>
            <ul className="mt-4 space-y-2">
              {LANDING_NAV.map(({ label, href }) => (
                <li key={href}>
                  <a href={href} className="inline-flex min-h-11 items-center text-sm text-slate-500 hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/20">
                    {label}
                  </a>
                </li>
              ))}
              <li>
                <a href={`#${LANDING_ANCHORS.contato}`} className="inline-flex min-h-11 items-center text-sm text-slate-500 hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/20">
                  Contato
                </a>
              </li>
              <li>
                <a href={LOGIN_PATH} className="inline-flex min-h-11 items-center text-sm text-slate-500 hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/20">
                  Entrar no painel
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xs font-semibold uppercase tracking-wider text-slate-400">
              Contato
            </h3>
            <ul className="mt-4 space-y-3">
              <li>
                <a
                  href={LANDING_CONTACT.whatsappUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex min-h-11 min-w-0 items-center gap-2 text-sm text-slate-500 hover:text-emerald-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/20"
                >
                  <MessageCircle className="h-4 w-4" />
                  WhatsApp
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${LANDING_CONTACT.email}`}
                  className="inline-flex min-h-11 min-w-0 items-center gap-2 break-all text-sm text-slate-500 hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/20"
                >
                  <Mail className="h-4 w-4" />
                  {LANDING_CONTACT.email}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xs font-semibold uppercase tracking-wider text-slate-400">
              Legal
            </h3>
            <ul className="mt-4 space-y-2 text-sm text-slate-500">
              <li>
                <span>Dados tratados conforme LGPD</span>
              </li>
              <li>
                <span>Planos e valores sob consulta comercial</span>
              </li>
            </ul>
          </div>
        </div>

        <p className="mt-10 border-t border-white/[0.04] pt-6 text-center text-xs text-slate-600">
          DS Espetos Grill © {ano} · Digital Signage
        </p>
      </div>
    </footer>
  );
}
